/**
 * The RainDrop component renders a rain drop SVG image.
 *
 * props:
 * - size: Width & height (pixels) of the image
 * - fill: The fill color of the rain drop
 */

const RainDrop = props => (
	<svg width={props.size} height={props.size} viewBox="0 0 400 400" preserveAspectRatio="none">
		<path transform="translate(70,30)" fill={props.fill} d="M 243.44676,222.01677 C 243.44676,288.9638 189.17548,343.23508 122.22845,343.23508 C 55.281426,343.23508 1.0101458,288.9638 1.0101458,222.01677 C 1.0101458,155.06975 40.150976,142.95572 122.22845,0.79337431 C 203.60619,141.74374 243.44676,155.06975 243.44676,222.01677 z" />
	</svg>
);

export default RainDrop;



// WEBPACK FOOTER //
// ./components/rain-drop/index.js